module.exports = __webpack_public_path__ + "9672970c.woff";